module.exports = __webpack_public_path__ + "a5aef832cf03e34b.svg";